<template>
  <v-container fluid class="pt-0">
    <v-row justify="center">
          <v-icon class="mx-2" size="35px">person_remove</v-icon>

          <span style="font-size: 24px; color: #616161">Credito empleado</span>
        </v-row>
    <v-row align="stretch">
      <v-col md="2" class="pr-0 pt-0">
        <v-card width="100%" outlined height="25vh">
          <v-card-text class="px-0">
            <v-container fluid>
              <v-text-field
                autofocus
                label="Codigo empleado"
                v-model="employee_code"
                @keypress.enter="loadData()"
                autocomplete="off"
                required
                outlined
                dense
              ></v-text-field>
              <v-btn
                block
                outlined
                color="primary"
                @click="loadData()"
                :loading="loading"
              >
                <v-icon>search</v-icon> Buscar
              </v-btn>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="10" class="pt-0">
        <v-card outlined height="25vh">
            <v-card-text v-if="employee_data.entity_id!=null">
                <v-row align="center" justify="center">
                  <v-col md="5" align="center">
                    <div class="text-subtitle-3 mb-1">Nombre</div>
                    <v-hover v-slot="{ hover }">
                        <span
                        @click="viewEntity(employee_data.entity_id)"
                        style="font-size: 14px"
                        class="text-h7 primary--text font-weight-bold"
                        :style="{
                            color: hover ? 'red' : 'black',
                            cursor: hover ? 'pointer' : '',
                            'text-decoration': hover ? 'underline' : '',
                        }"
                        >{{ employee_data.name }}</span
                        ></v-hover
                    >
                  </v-col>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <v-col md="3" align="center">
                    <div class="text-subtitle-3 mb-1">Identificacion</div>
                    <div class="text-h7 primary--text font-weight-bold">
                      {{ employee_data.document_id }}
                    </div>
                  </v-col>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <v-col md="3" align="center">
                    <div class="text-subtitle-3 mb-1">Disponible para consumo</div>
                    <div
                      class="text-h6 font-weight-bold"
                      :style="`color: ${employee_data.available > 0 ? '#00897B' : '#E53935'};`"
                    >
                      {{
                        validate_available()
                      }}
                    </div>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row align="center" justify="center">
                  <v-col md="5" align="center">
                    <div class="text-subtitle-3 mb-1">Unidad de negocios</div>
                    <div class="text-h7 primary--text font-weight-bold">
                      {{ employee_data.e_business_unit }}
                    </div>
                  </v-col>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <v-col md="3" align="center">
                    <div class="text-subtitle-3 mb-1">Planta</div>
                    <div class="text-h7 primary--text font-weight-bold">
                      {{ employee_data.e_location }}
                    </div>
                  </v-col>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <v-col md="3" align="center">
                    <v-row align="center" justify="center">
                        <v-col md="12" align="center" class="mt-2 pb-0">
                            <div class="text-subtitle-3 mb-1">Balance pendiente</div>
                            <div
                              class="text-h7 font-weight-bold"
                              :style="`color: ${
                                temp_data.pending_balance > 0 ? '#E53935' : '#00897B'
                              };`"
                            >
                              {{
                                employee_data.entity_id != null ? currencyFormat(temp_data.pending_balance) : ""
                              }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row align="center">
                    <v-col md="12" align="center" class="pt-0">
                        <span class="mr-2 mb-2">Bloqueado: {{employee_data.pos_exclude?'Si':'No'}}</span>
                        <v-btn v-if="hasFeature('ING-092')" icon @click="update_exclude_status()" :loading="loading_update_exclude">
                            <v-icon style="font-size: 45px;" color="error" v-if="employee_data.pos_exclude">toggle_on</v-icon>
                            <v-icon style="font-size: 45px;" color="success" v-else>toggle_off</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                  </v-col>
                </v-row>
            </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-card outlined class="mt-2">
      <v-data-table
        height="40vh"
        :search="search"
        :headers="headers"
        :items-per-page="45"
        :items="invoices"
        dense :loading="loading_invoices"
        fixed-header
      >
        <template v-slot:top>
          <v-toolbar class="elevation-0 rounded-lg">
            <v-toolbar-title>Pendientes: {{ invoice_count }} {{ invoices.length>1?`de ${invoices.length}`:'' }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-col md="4">
              <v-text-field
                label="Buscar..."
                class="mt-0"
                v-model="search"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
             <v-col cols="12" sm="2" md="2" class="px-0 mr-1">
                <v-autocomplete
                v-model="invoice_type"
                :items="invoice_range_types"
                label="Rango"
                dense hide-details
                outlined @change="update_range()"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="px-0 mr-1" v-if="invoice_type==4">
              <v-menu
                ref="menuDesde"
                v-model="menuDesde"
                :close-on-content-click="false"
                :return-value.sync="filterSetting.start_date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_format_dmy_tart"
                    label="Desde"
                    prepend-inner-icon="today"
                    dense
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterSetting.start_date"
                  no-title
                  scrollable
                  :max="filterSetting.end_date"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="menuDesde = false">
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuDesde.save(filterSetting.start_date),get_employee_invoices(false, filterSetting.start_date,filterSetting.end_date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" md="2" class="px-0" v-if="invoice_type==4">
              <v-menu
                ref="menuHasta"
                v-model="menuHasta"
                :close-on-content-click="false"
                :return-value.sync="filterSetting.end_date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_format_dmy_end"
                    label="Hasta"
                    @change="updateInvoices('ALL')"
                    dense
                    prepend-inner-icon="insert_invitation"
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filterSetting.end_date"
                  no-title
                  scrollable
                  :min="filterSetting.start_date"
                  :max="filterSetting.today"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="menuHasta = false">
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menuHasta.save(filterSetting.end_date),get_employee_invoices(false, filterSetting.start_date,filterSetting.end_date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-toolbar>
        </template>
        <template v-slot:[`item.invoice_number`]="{ item }">
          <v-hover v-slot="{ hover }">
            <span
              @click="showInvoice(item.invoice_id, true)"
              class="primary--text font-weight-normal text-truncate font-weight-semibold"
              :style="{
                color: hover ? 'red' : 'black',
                cursor: hover ? 'pointer' : '',
                'text-decoration': hover ? 'underline' : '',
              }"
            >
              <span class="red--text d-flex" v-if="item.cre_inb_id === 7">
              </span>

              {{ item.invoice_number }}

              <v-icon v-if="item.box_id">mdi-point-of-sale</v-icon>
            </span>
          </v-hover>
          <br />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                medium
                color="primary"
                class="mr-2"
                v-bind="attrs"
                v-on="on" :disabled="item.last_pay.length==0"
                @click="showPayments(item)"
              >
                read_more
              </v-icon>
            </template>
            <span>Ver pagos</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pt-10">
            <v-icon size="80px">token</v-icon>
          </v-row>
          <v-row justify="center" class="pb-6">No hay facturas en este rango de fechas</v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog width="40%" v-model="show_payments">
        <v-card>
            <v-card-title>Pagos de la factura {{ select_invoice_number }}</v-card-title>
            <v-card-text>
                <v-data-table class="pt-0" :headers="header_payments" :items="payments" hide-default-footer></v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    search: null,
    employee_code: null,
    loading: false,
    loading_invoices: false,
    loading_update_exclude: false,
    menuDesde: false,
    show_payments:false,
    menuHasta: false,
    select_invoice_number:null,
    invoice_type:0,
    temp_data:{
      code:null,
      pending_balance:0
    },
    invoice_range_types:[{value:0,text:"Con balance pendiente"},{value:1,text:"Esta semana"},{value:2,text:"Este mes"},{value:3,text:"Este año"},{value:4,text:"Personalizado"}],
    payments:[],
    employee_data: {
      document_id: null,
      name: null,
      is_supplier: null,
      is_customer: null,
      currency_id: null,
      pos_exclude: null,
      status_id: null,
      available: null,
      e_business_unit: null,
      e_location: null,
      e_job_title_name: null,
      employee_status: null,
      pos_exclude:false
    },
    invoices: [],
    headers: [
      {
        text: "Fecha",
        align: "start",
        value: "date",
      },
      { text: "Codigo", value: "invoice_number" },
      { text: "Concepto", value: "concepto" },
      { text: "Monto", value: "amount", align: "end" },
      { text: "Cuotas", value: "cre_payments_qty" },
      { text: "Abonado", value: "payment", align: "end" },
      {
        text: "Balance pendiente",
        value: "pending_balance_format",
        align: "end",
      },
      { text: "", value: "actions", sortable: false },
    ],
    header_payments: [{
        text: "Fecha",
        align: "start",
        value: "formated_pay_date_end",
        },
        { text: "Nomina", value: "payroll_code" },
        { text: "Abono", value: "formated_amount_paid", align: "end" },
        { text: "Balance pendiente", value: "formated_pending_balance", align: "end" },
        ],
    filterSetting: {
      start_date: moment().startOf('week').format('YYYY-MM-DD'),
      end_date: moment().endOf('week').format('YYYY-MM-DD'),
      today: moment().format("YYYY-MM-DD"),
    },
  }),
  computed: {
    date_format_dmy_tart() {
      return moment(this.filterSetting.start_date).format("DD/MM/YYYY");
    },
    date_format_dmy_end() {
      return moment(this.filterSetting.end_date).format("DD/MM/YYYY");
    },
    // pending_balance() {
    //   let balance = 0;
    //   for (let item of this.invoices) {
    //     balance += parseFloat(item.pending_balance);
    //   }
    //   return balance;
    // },
    invoice_count(){
      let count = 0;
      for (let item of this.invoices) {
        if( parseFloat(item.pending_balance)>0.5){
            count++;
        }
      }
      return count;
    }
  },
  methods: {
    async loadData() {
        this.invoice_type=0;
        this.get_employee_credit();
        this.get_employee_invoices(true, null, null);
    },
    async get_employee_credit() {
        if (this.employee_code==null || this.employee_code == "" || this.employee_code.length>6) {
            this.$toast.error("Codigo no valido!");
            this.clear();
            return;
        }
      this.loading = true;
      try {
        const result = await this.api_Get(`entity/employee_credit/${this.clearInputFilter(this.employee_code,6)}`
        );
        const data = await result.json();
        if(data.length==0){
            this.$toast.info("Empleado no encontrado!");
            this.clear();
            this.loading = false;
            return
        }
        this.employee_data = data[0];
        this.employee_data.name=this.employee_data.name.slice(0,65);
      } catch (error) {
        this.$toast.error(error.message);
        this.loading = false;
      }
      this.loading = false;
    },
    async get_employee_invoices(is_pending_only, start, end) {
        if (this.employee_code==null || this.employee_code == "" || this.employee_code.length>6) {
            this.$toast.error("Codigo no valido!");
            return;
        }
      this.loading_invoices = true;
      this.invoices = [];
      try {
        const result = await this.api_Post(`entity/employee_invoices`, {
          employee_code: this.clearInputFilter(this.employee_code, 6),
          pending_only: is_pending_only,
          start_date: start,
          end_date: end,
        });
        const data_invoices = await result.json();

        let balance=0;
        for (let item of data_invoices) {
          let invoice = item;
          invoice.date = moment(item.date).format("DD/MM/YYYY");
          balance+=parseFloat(item.pending_balance);
          invoice.pending_balance_format = this.currencyFormat(item.pending_balance);
          invoice.amount = this.currencyFormat(item.cre_amount);
          invoice.payment = this.currencyFormat(parseFloat(item.cre_amount) - parseFloat(item.pending_balance));
          invoice.last_pay_date = item.last_pay.length > 0? moment(item.last_pay[0].pay_date_end).format("DD/MM/YYYY"): "-";
          invoice.fee_amount = this.currencyFormat(parseFloat(item.cre_amount) / parseInt(item.cre_payments_qty));
          this.invoices.push(invoice);
        }
        if(this.temp_data.code!=this.employee_code){
          this.temp_data.pending_balance=balance;
        }
        this.temp_data.code=this.employee_code;
      } catch (error) {
        this.$toast.error(error.message);
        this.loading_invoices = false;
      }
      this.loading_invoices = false;
    },
    showPayments(invoice){
        this.select_invoice_number=invoice.invoice_number;
        this.payments=invoice.last_pay;
        for(let key in this.payments){
            this.payments[key].formated_amount_paid=this.currencyFormat(this.payments[key].amount_paid);
            this.payments[key].formated_pending_balance=this.currencyFormat(this.payments[key].pending_balance);
            this.payments[key].formated_pay_date_end=moment(this.payments[key].pay_date_end).format('DD/MM/YYYY');
        }
        this.show_payments=true;
    },
    update_range(){
        const range_type=['week','month','year']
        if(this.invoice_type==0){
            this.get_employee_invoices(true,null,null)
        }
        if(this.invoice_type==4){
            return
        }
        this.filterSetting.start_date=moment().startOf(range_type[this.invoice_type-1]).format('YYYY-MM-DD');
        this.filterSetting.end_date=moment().endOf(range_type[this.invoice_type-1]).format('YYYY-MM-DD');
        this.get_employee_invoices(false, this.filterSetting.start_date,this.filterSetting.end_date)
    },
    async update_exclude_status(){
        this.employee_data.pos_exclude=!this.employee_data.pos_exclude;
        this.loading_update_exclude=true;
        try {
            const result = await this.api_Put(`entity/update_pos_exclude`, {
                entity_id:this.employee_data.entity_id,
                exclude:this.employee_data.pos_exclude
                });
            if(result.status==200){
                this.$toast.success(`Empleado ${this.employee_data.pos_exclude?'bloqueado':'desbloqueado'} con exito!`)
            }
        } catch (error) {
            console.error(error.message);
            this.$toast.error(error.message);
            this.loading_update_exclude=false;
        }
        this.loading_update_exclude=false;
    },
    clear(){
        this.invoices = [];
        this.employee_data={
            document_id: null,
            name: null,
            is_supplier: null,
            is_customer: null,
            currency_id: null,
            pos_exclude: null,
            status_id: null,
            available: null,
            e_business_unit: null,
            e_location: null,
            e_job_title_name: null,
            employee_status: null,
            pos_exclude:false
            }
    },
    validate_available(){
      if(this.employee_data.entity_id == null){
        return ''
      } 
      if(this.employee_data.available<0){
        return 0
      }
      return this.employee_data.available > 10000? '+10,000':this.currencyFormat(this.employee_data.available)
    }
  },
};
</script>
